import { Link } from "react-router-dom";
import { Sparkles, X } from "lucide-react";

// Sticky bottom-right credit-pack upsell. Shown only to anonymous / first-time
// users who haven't dismissed it yet. Logic for "should I show this" lives in
// the parent page so this component stays presentational.
export function WorkflowCreditUpsell({ show, onDismiss, hasUser }) {
    if (!show) return null;
    return (
        <div
            data-testid="workflow-credit-upsell"
            className="tr-upsell-card fixed z-40 left-4 right-4 bottom-4 sm:left-auto sm:right-6 sm:bottom-6 sm:w-[380px]"
            role="complementary"
            aria-label="Buy your first credit pack"
        >
            <div className="relative rounded-2xl bg-gradient-to-br from-[#0B1120] via-[#0f2944] to-[#134e4a] text-white shadow-2xl shadow-cyan-900/40 ring-1 ring-cyan-400/30 overflow-hidden">
                <div className="absolute -top-16 -right-10 w-48 h-48 rounded-full bg-cyan-400/25 blur-3xl pointer-events-none" />
                <button
                    onClick={onDismiss}
                    data-testid="workflow-upsell-dismiss"
                    aria-label="Dismiss"
                    className="absolute top-2.5 right-2.5 z-10 w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 grid place-items-center text-white/70 hover:text-white transition"
                >
                    <X size={14} />
                </button>
                <div className="relative p-5 pr-10">
                    <div className="flex items-center gap-2">
                        <div className="px-2 py-0.5 rounded-full bg-emerald-400/15 border border-emerald-300/40 text-emerald-200 text-[10.5px] font-semibold tracking-wider uppercase">
                            Save 15%
                        </div>
                        <div className="font-mono-tr text-[10px] tracking-[0.22em] uppercase text-cyan-200/80">
                            · First-pack offer
                        </div>
                    </div>
                    <div className="mt-3 font-display text-[20px] leading-tight tracking-tight">
                        Buy your first credit pack
                    </div>
                    <p className="mt-1.5 text-[12.5px] text-white/70 leading-snug">
                        Prepay your cases in QAR and save up to <span className="text-white font-semibold">15%</span> — credits never expire, auto-debit on every order.
                    </p>
                    <div className="mt-4 flex items-center gap-2">
                        <Link
                            to={hasUser ? "/portal#credits" : "/pricing"}
                            data-testid="workflow-upsell-cta"
                            className="flex-1 inline-flex items-center justify-center gap-1.5 py-2.5 rounded-xl bg-cyan-400 text-[#022c33] hover:bg-cyan-300 text-[13px] font-semibold transition"
                        >
                            <Sparkles size={14} /> See packs
                        </Link>
                        <Link
                            to="/pricing"
                            data-testid="workflow-upsell-learn"
                            className="inline-flex items-center justify-center px-3 py-2.5 rounded-xl bg-white/10 hover:bg-white/15 text-white text-[12.5px] font-medium transition border border-white/10"
                        >
                            FAQs
                        </Link>
                    </div>
                    <div className="mt-2.5 text-[10.5px] text-white/40 tracking-wide">
                        Visa · Mastercard · Amex · Bank transfer
                    </div>
                </div>
            </div>
        </div>
    );
}
